import React, { useEffect } from 'react';

// 관리자 레이아웃 — 헤더·푸터 없이 관리자 틀(AdminShell)만 그린다
function AdminLayout({ children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return <React.Fragment>{children}</React.Fragment>;
}

export default AdminLayout;
